import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  FormControl,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
  Typography
} from "@material-ui/core";
import PersonIcon from "@mui/icons-material/Person";
import TabletMacIcon from "@mui/icons-material/TabletMac";

const RecallToDeviceModal = props => {
  const deviceNameMenuItems = props.devices.map(d => (
    <MenuItem value={d.identifier} key={d.identifier}>
      {d.type === "Device" ? <TabletMacIcon /> : <PersonIcon />}
      {props.modalData.submission_device === d.name ||
      props.modalData.submission_device === d.email ? (
        <b>{d.name || d.email} (Issuing Device)</b>
      ) : (
        d.name || d.email
      )}
    </MenuItem>
  ));

  // If this is an update, show the diff between the old row and new row.
  // otherwise its an insert, just show new data.
  return (
    <Dialog
      open={props.recallToDeviceModalOpen}
      fullWidth
      max-width="400"
      onClose={props.onRecallCloseClick}
      scroll="body"
    >
      <DialogTitle>Recall to Device</DialogTitle>
      <DialogContent>
        {props.isFetchingDevices ? (
          <div>
            <Typography>Loading Devices..</Typography>
            <LinearProgress />
          </div>
        ) : (
          <DialogContentText>
            <b>Form name:</b>
            <br /> {props.modalData.form_name}
            <FormControl fullWidth style={{ marginTop: "20px" }}>
              <InputLabel>Device</InputLabel>
              <Select
                value={props.deviceSelected.device}
                onChange={e => props.onRecallDeviceChange(e.target.value)}
              >
                {deviceNameMenuItems}
              </Select>
            </FormControl>
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          disabled={props.isFetchingDevices}
          onClick={props.onRecallSaveClick}
        >
          Recall
        </Button>

        <Button color="primary" onClick={props.onRecallCloseClick}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

RecallToDeviceModal.defaultProps = {
  recallToDeviceModalOpen: false
};

RecallToDeviceModal.propTypes = {
  modalData: PropTypes.shape({
    submission_device: PropTypes.string,
    form_name: PropTypes.string
  }).isRequired,
  onRecallSaveClick: PropTypes.func.isRequired,
  onRecallDeviceChange: PropTypes.func.isRequired,
  onRecallCloseClick: PropTypes.func.isRequired,
  deviceSelected: PropTypes.shape({
    device: PropTypes.string.isRequired
  }).isRequired,
  isFetchingDevices: PropTypes.bool.isRequired,
  devices: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      identifier: PropTypes.string,
      organizationId: PropTypes.string,
      owner: PropTypes.string,
      description: PropTypes.string,
      pendingApproval: PropTypes.string,
      groups: PropTypes.arrayOf(PropTypes.string)
    })
  ).isRequired,

  recallToDeviceModalOpen: PropTypes.bool
};

export default RecallToDeviceModal;
